module.exports = __webpack_public_path__ + "static/media/lachico.d82392fe.jpeg";